export default {
  no_mobile_app: 'Geen mobiele app geconfigureerd',
  mobile_app_not_live: 'Mobiele app niet actief',
};
